<template>
    <div class="p-fluid" style="direction: rtl">
        <div class="card  p-d-flex p-jc-center">
            <DataTable
                    :rowClass="rowClass"
                    :value="data"

                    :selection.sync="selectedSystemMessages"
                    @cell-edit-complete="onCellEditComplete"
                    columnResizeMode="fit"
                    dataKey="id"
                    stateStorage="local"
                    stateKey="system-messages-data-state"
                    editMode="cell"
                    :loading="loading"
                    sortField="createdAt"
                    :sortOrder="-1"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 20, 50]"
                    currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
            >
                <!-- header -->

                <template #header>
                    <div class="p-p-2 table-header">
                        <div class="p-m-1 p-d-inline-flex">
                            <h1 style="text-align: center">הודעות מערכת</h1>
                        </div>

                        <div class="p-d-flex">

                            <Button
                                    v-tooltip.top="'מחיקה'"
                                    v-if="selectedSystemMessages.length > 0"
                                    icon="pi pi-trash"
                                    class="p-mr-2 p-button-danger"
                                    @click="isDialogDelete = true"
                            />
                            <Button
                                    v-tooltip.top="'הוספה'"
                                    icon="pi pi-plus"
                                    class="p-mr-2 p-button-success"
                                    @click="isDialogAdd = true"
                            />
                        </div>
                    </div>
                </template>
                <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
                <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

                <!-- id -->

<!--                <Column-->
<!--                        headerStyle="width: 5%;"-->
<!--                        bodyStyle="text-align: right; overflow: visible ; color: #757575;"-->
<!--                        field="id"-->
<!--                        header="ת.ז"-->
<!--                        sortable-->
<!--                >-->
<!--                    <template #filter>-->
<!--                        <InputText-->
<!--                                type="text"-->
<!--                                v-model="filters['id']"-->
<!--                                class="p-column-filter"-->
<!--                                placeholder="חפש לפי ת.ז."-->
<!--                        />-->
<!--                    </template>-->
<!--                </Column>-->

                <!-- v-for -->
                <Column
                        headerStyle="text-align: rtl"
                        bodyStyle="text-align: right; overflow: visible"
                        sortable
                        v-for="col of columns"
                        :field="col.field"
                        :header="col.header"
                        :key="col.field"
                >

                    <template #editor="slotProps">
                        <Textarea
                            autoResize="true"
                                @input="onCellEdit($event, slotProps)"

                                v-if="slotProps.column.field !== 'id'"
                                :value="slotProps.data[slotProps.column.field]"
                        />
                        <div v-else>{{ slotProps.data[slotProps.column.field] }}</div>
                    </template>
                </Column>

                <!-- start date-->
                <Column
                        bodyStyle="text-align: right; overflow: visible"
                        :field="'startDate'"
                        header="'תאריך התחלה'"
                >
                    <template #body="slotProps">
                        {{new Date(slotProps.data.startDate).toLocaleDateString()}}
                    </template>
                    <template #editor="slotProps">
                        <Calendar
                                                            @input="onCellEdit($event, slotProps)"
                                                                  :touchUI="true"
                                   :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data.startDate)" />
                    </template>
                </Column>

                <!-- end -->
                <Column
                        bodyStyle="text-align: right; overflow: visible"
                        :field="'endDate'"
                        header="'תאריך סיום'"
                >
                    <template #body="slotProps">
                        {{new Date(slotProps.data.endDate).toLocaleDateString()}}
                    </template>
                    <template #editor="slotProps">
                        <Calendar
                                @input="onCellEdit($event, slotProps)"
                                :touchUI="true"
                                :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data.endDate)" />
                    </template>
                </Column>

                <!-- type -->

                <Column

                        headerStyle="width: 15%; text-align: rtl"
                        bodyStyle="text-align: right; overflow: visible"
                        sortable
                        sortField="type"
                        :field="'type'"
                        header="'סוג'"
                        :key="'type'"
                >

                    <template #editor="slotProps">
                        <Dropdown
                                @input="onCellEdit($event, slotProps)"

                                :class="`t-${slotProps.data[slotProps.column.field]}`"
                                :value="slotProps.data[slotProps.column.field]"
                                :options="types"
                        >
                            <template #option="slotProps">
                <span class="subject-tracking " :class="`t-${slotProps.option}`">
                  {{ getTypeLabel(slotProps.option) }}
                </span>
                            </template>
                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                  <span class="subject-tracking " :class="`t-${slotProps.option}`">
                    {{ getTypeLabel(slotProps.value) }}
                  </span>
                                </div>
                                <span v-else>
                  {{ slotProps.placeholder }}
                </span>
                            </template>
                        </Dropdown>

                    </template>
                    <template #body="slotProps">
                        <div class="subject-tracking " :class="`t-${slotProps.data.type}`">
                            {{ getTypeLabel(slotProps.data.type) }}
                        </div>
                    </template>
                </Column>
<!--                active-->
                <Column
                        headerStyle="width: 5%; text-align: rtl"
                        bodyStyle="width: 5%; text-align: right; overflow: visible"
                        :field="'active'"
                        :header="'פעיל'"
                >
                    <template #editor="slotProps">
                        <checkbox                                 @input="onCellEdit($event, slotProps)"
                                                                  v-model="slotProps.data.active" :binary="true"></checkbox>
                    </template>
                    <template #body="slotProps">
                        <checkbox v-model="slotProps.data.active" :binary="true"></checkbox>
                    </template>
                </Column>
<!--                days in week-->
                <Column
                        bodyStyle="text-align: right; overflow: visible"
                        :field="'daysInWeek'"
                        header="'ימים בשבוע'"
                >
                    <template #editor="slotProps">
                        <MultiSelect                                 @input="onCellEdit($event, slotProps)"
                                                                    v-model="slotProps.data.daysInWeek"  :options="daysInWeek" placeholder="ימים בשבוע" />
                    </template>
                    <template #body="slotProps">
                        <MultiSelect  v-if="slotProps.data.daysInWeek" v-model="slotProps.data.daysInWeek"  :options="daysInWeek" placeholder="ימים בשבוע" />
                    </template>
                </Column>




                <template #footer>
                    סה״כ {{ data ? data.length : 0 }} רשומות.
                </template>
            </DataTable>
        </div>

        <add-dialog
                :show="isDialogAdd"
                v-on:addItem="addItem"
                v-on:closeDialog="isDialogAdd = false"
        />

        <delete-dialog
                :title="'מחיקת משתמש'"
                :context="`האם תרצה להסיר  ${selectedSystemMessages.length}   הודעות מהמערכת?`"
                :show="isDialogDelete"
                v-on:choice="deleteItem"
        />

    </div>
</template>

<script>
import addDialog from "./SystemMessagesDialog.vue";
import deleteDialog from "../../../../dialogs/DeleteDialog.vue";
import Service from "../../../../service/Service";
import Vue from "vue";

export default {
    service: null,
    name: "SystemMessages",
    components: {
        addDialog,
        deleteDialog,
    },
    created() {
        this.service = new Service();
    },
    methods: {
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        async onCellEditComplete(updateItem, bb) {
            const index = this.data.findIndex(
                (item) => item.id === this.itemAfterEditing.id
            );
            this.data[index] = this.itemAfterEditing;
            Vue.set(this.data, index, this.itemAfterEditing);
            const clone = JSON.parse(JSON.stringify(this.itemAfterEditing));
clone.startDate = new Date(clone.startDate).getTime()
clone.endDate = new Date(clone.endDate).getTime()
if (!clone.id) throw "error"
            await this.service
                .post(clone, this.ENTITY)
                .then((data) => {
                    this.openNotification(
                        "success",
                        `מעולה`,
                        `ההודעה התעדכנה`
                    );

                })
                .catch(() => {
                    this.openNotification(
                        "danger",
                        `אופס`,
                        `ההודעה לא התעדכנה`
                    );
                });
        },
        addItem(item) {
            this.data.push(item);
        },
        deleteItem(choice) {
            this.loading = true

            this.isDialogDelete = false;
            if (choice) {
                const itemsIds = [];
                this.selectedSystemMessages.forEach((item) => {
                    itemsIds.push(item.id);
                });

                this.selectedSystemMessages.forEach((selected) => {
                    this.data = this.data.filter((item) => item.id !== selected.id);
                });

                this.service.deleteMany(itemsIds, this.ENTITY).then(() => {
                        this.loading = false
                        this.openNotification("success", `מעולה`, `מחקנו ${itemsIds.length}  רשומות מהמערכת`);
                        this.selectedSystemMessages = [];
                    }).catch(() => {
                        this.loading = false
                        this.openNotification("danger", `אופס`, `לא הצלחנו למחוק את הרשומות מהמערכת`);
                        this.data.push(...this.selectedSystemMessages)
                        this.selectedSystemMessages = [];
                    });

                this.isDialogDelete = false;
            }
        },
        rowClass(data) {
            return data.active === false ? "row-unenabled" : null;
        },

        getTypeLabel(status) {
            switch (status) {
                case "error":
                    return "סכנה";
                case "warn":
                    return "אזהרה";
                case "success":
                    return "הצלחה";
                case "info":
                    return "מידע";
                default:
                    return "שגיאה";
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    },
    async mounted() {
        try {
          const messages  = await this.service.getSystemMessages()
            // const fullMessages =  messages.map(systemMessage => {
            //     if (systemMessage.daysInWeek){
            //        const daysInWeek = systemMessage.daysInWeek.map(day => {return {value: day, display: this.getDisplayDay(day)}})
            //        return {...systemMessage, daysInWeek : daysInWeek}
                    // return {...systemMessage,  daysInWeek: {value: systemMessage.daysInWeek, display: systemMessage.daysInWeek}}
                // }

                // return systemMessage
    // });
          // console.log("fullMessages", fullMessages)
            this.data = messages
            this.loading = false;
        } catch (e) {
            console.log( e)
        }
    },
    data() {
        return {
            ENTITY: 'system-messages',
            daysInWeek: [1,2,3,4,5,6,7 ],
            data: null,
            loading: true,
            isDialogDelete: false,
            isDialogAdd: false,
            selectedSystemMessages: [],
            filters: {},
            itemBeforeEditing: {},
            itemAfterEditing: {},
            columns: [{field: "content", header: "תוכן"}, {field: "sort", header: "סדר"}],
            types: ["error","warn","success", "info"],
        }
    },
    
}
</script>

<style scoped>

</style>